module.exports = require("web-streams-polyfill");